import { ReportEventDataEvent } from "../types";
import { getAnalyticsReport } from "./store";

export const handleReport = ({ platform, measurementId, data }: ReportEventDataEvent) => {
  const report = getAnalyticsReport(platform, measurementId);

  if (!report) {
    window.console.warn('No report function for: ', platform, measurementId, '(platform may have failed to initialize)');
    return;
  }

  try {
    report(...data);
  } catch (error) {
    window.console.error('Error reporting to ', platform, measurementId, ':', error);
  }
}